import { ObjectMapper } from 'json-object-mapper';
import { Model } from '../../model';
import { IModel } from '../../IModel';
import { BenefitTypeEnum } from 'services/enums/benefitsType.enum';

export class BenefitsEmployeeModel extends Model implements IModel<BenefitsEmployeeModel> {
  benefitPlanId: string | undefined = undefined;
  employeeId: string | undefined = undefined;
  currentPetitionId: string | undefined = undefined;
  dateBegin: string = '';
  dateEnd: string | undefined = undefined;
  competenceDate: string | undefined = undefined;
  walletNumber: string = '';

  providerId: string | undefined = undefined;
  benefitType: string = '';
  benefitDescription: string = '';
  providerName: string = '';
  providerLogo: string = '';
  hasDependents: boolean = false;
  requestInProgress: boolean = false;

  get customizeBenefit(): string {
    return `<b class="text-primary">${this.benefitDescription}</b><br>${this.benefitTypeLabel}`;
  }

  get benefitTypeLabel(): string {
    return BenefitTypeEnum.getBy(this.benefitType).label;
  }

  static create(input: any): BenefitsEmployeeModel {
    return ObjectMapper.deserialize<BenefitsEmployeeModel>(BenefitsEmployeeModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
